import ProfileSuggestionModal from './ProfileSuggestionModal';
export default ProfileSuggestionModal;